import { ShieldCheck } from 'lucide-react'
import { NavLink, Outlet } from 'react-router'

import { cn } from '@/lib/cn'
import { Card } from '@/components/ui/Card'

const TABS = [
  { label: 'Overblik', to: '/app/platform', end: true },
  { label: 'Kunder', to: '/app/platform/kunder', end: false },
  { label: 'Brugere', to: '/app/platform/brugere', end: false },
]

/**
 * Ramme om platformadministrationen.
 *
 * Båndet øverst er der med vilje. Den samme person bruger appen både som
 * leverandør og som medlem af sin egen organisation, og herinde ser man andre
 * virksomheders data. Det skal ikke kunne forveksles med den almindelige app —
 * en fejltagelse dér er en fejltagelse i en fremmed kundes oplysninger.
 */
export function PlatformLayout() {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-3 rounded-[var(--radius-panel)] border border-warning-500/30 bg-warning-500/10 px-4 py-2.5">
        <ShieldCheck className="size-4 shrink-0 text-warning-300" aria-hidden="true" />
        <p className="text-[13px] text-warning-200">
          <span className="font-medium">Platformadministration.</span> Du ser data på tværs af alle
          kunder. Handlinger her bliver registreret i kundens eget spor.
        </p>
      </div>

      <Card as="panel" className="overflow-x-auto p-1">
        <nav aria-label="Platformadministration">
          <ul className="flex min-w-max gap-1">
            {TABS.map((tab) => (
              <li key={tab.to}>
                <NavLink
                  to={tab.to}
                  end={tab.end}
                  className={({ isActive }) =>
                    cn(
                      'block rounded-lg px-4 py-2 text-[13px] font-medium transition-colors',
                      'focus-visible:outline-2 focus-visible:outline-brand-400',
                      isActive
                        ? 'bg-brand-500/20 text-text-primary'
                        : 'text-text-secondary hover:bg-overlay-soft',
                    )
                  }
                >
                  {tab.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </Card>

      <Outlet />
    </div>
  )
}
